import "font-awesome/css/font-awesome.css";
import Vue from "vue";
import VueTheMask from "vue-the-mask";
import money from "v-money";

// --- NOVAS LINHAS PARA SOCKET.IO ---
import io from "socket.io-client";
import { baseApiUrl } from "@/global"; // Importa baseApiUrl do seu arquivo global.js

const socket = io(baseApiUrl); // Usa a baseApiUrl para conectar o Socket.IO
Vue.prototype.$socket = socket; // Torna a instância do socket acessível como this.$socket em todos os componentes
// --- FIM DAS NOVAS LINHAS PARA SOCKET.IO ---

Vue.use(money);
Vue.use(VueTheMask);

import moment from "moment";
Vue.prototype.moment = moment;
moment.locale("pt-br");

Vue.filter("dt_emissao", function (value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
  }
});

import App from "./App";

import "./config/bootstrap";
import "./config/msgs";
import "./config/axios";
import "./config/mq";

import store from "./config/store";
import router from "./config/router";

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
